import Flex from '@Components/Bases/Flex';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { useGoalAndOperationalPlansForm } from '../GoalAndOperationalPlansFormProvider';
import { IOverviewFormValues } from '../GoalAndOperationalPlansFormProvider/types';

const GoalAndOperationalPlansOverview = () => {
  const { introduction, remark } =
    useWatch({
      name: 'overview',
    }) ?? ({} as IOverviewFormValues);

  const [
    openIntroduction,
    { open: openIntroductionDialog, close: closeIntroduction },
  ] = useDisclosure(!!introduction);

  const [openRemark, { open: openRemarkDialog, close: closeRemark }] =
    useDisclosure(!!remark);

  const { control } = useGoalAndOperationalPlansForm();

  const completedSection = useWatch({
    control,
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection || {};

  return (
    <Flex p={2} flexDirection={'column'} bgcolor={'white'} gap={2}>
      <Flex gap={1}>
        <Typography fontWeight={700}>
          แผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยง
        </Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <IntroductionButton
            onClick={openIntroductionDialog}
            disabled={isCompletedTh && isCompletedEn}
          />
          <RemarkButton
            onClick={openRemarkDialog}
            disabled={isCompletedTh && isCompletedEn}
          />
        </Flex>
      </Flex>
      {openIntroduction && (
        <Introduction
          onDelete={closeIntroduction}
          topic="แผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยง"
          setOpen={openIntroductionDialog}
          fieldPath="overview.introduction"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
      {openRemark && (
        <Remark
          onDelete={closeRemark}
          topic="แผนการเพิ่มมูลค่าองค์กร และการบริหารความเสี่ยง"
          setOpen={openRemarkDialog}
          fieldPath="overview.remark"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
    </Flex>
  );
};

export default GoalAndOperationalPlansOverview;
